<section class="mat-typography mat-body">
  <!-- Login -->
  <div class="clickable">
    <a href="javascript:void(0)" class="header-text" (click)="loginTrigger()">
      <slot name="login"><span>LOGIN</span></slot>
    </a>
  </div>

  <div><span>or</span></div>

  <!-- Register -->
  <div class="clickable">
    <a href="javascript:void(0)" class="header-text" (click)="registerTrigger()">
      <slot name="register"><span>REGISTER</span></slot>
    </a>
  </div>
</section>
